// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  width: 200px;
  background-color: var(--mp-tree-item-current-color);
  color: white;
  padding: 15px;
  position: fixed;
  top: 0;
  bottom: 0px;
  /*height: calc(100vh - 70px);*/
  left: 0;
  transition: width 0.3s ease-in-out;
  overflow: visible;
  display: flex;
  flex-direction: column;
  z-index: 1000;
}

.sidebar-footer {
  margin-top: auto;
  background-color: var(--mp-view-bar-current-color);
  padding: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  height: 58px;
  display: none;
}

.sidebar-footer .feedback-icon {
  margin-right: 5px;
}

.sidebar-footer .sidebar-text {
  padding-bottom: 20px;
}

.sidebar-link-vertical {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
  width: 100%;
}

.feedback-icon {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 16px;
}

.sidebar-link-vertical .sidebar-text-home {
  font-family: "Microsoft JhengHei";
}

.sidebar-link-vertical .sidebar-text {
  margin-left: 10px;
  margin-top: 5px;
  text-align: center;
  font-size: small;
  font-family: "Microsoft JhengHei";
  padding: 0;
  display: inline-block;
}

.sidebar.expanded + .content {
  margin-left: 200px;
}

.sidebar.compressed + .content {
  margin-left: 70px;
  margin-right: 0;
}

/*.sidebar-link-vertical svg{
  margin-bottom: 5px;
}*/
.feedback-icon .sidebar-text {
  margin-left: 5px;
}

.feedback-icon span {
  margin-left: 5px;
}

.sidebar.compressed {
  width: 70px;
}

.sidebar.expanded {
  width: 200px;
}

.sidebar-toggle {
  cursor: pointer;
  border: black;
  width: 29px;
  height: 29px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  transition: background-color 0.3s;
  padding: 10px;
  position: absolute;
  right: -14.5px;
  top: 60px;
  background-color: white;
  text-align: center;
  transition: transform 0.3s ease-in-out, background-color 0.3s;
  z-index: 5000;
}

.sidebar-toggle svg {
  transition: transform 0.3s ease-in-out;
  color: black;
}

.sidebar ul {
  list-style-type: none;
  padding: 0;
  margin-top: 0;
  white-space: nowrap;
}

.sidebar ul li {
  padding: 0;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  transition: font-size 0.3s ease-in-out;
}

.sidebar.compressed ul li {
  font-size: 12px;
  text-align: center;
}

.sidebar ul li .sidebar-text {
  margin-left: 10px;
  display: inline-block;
}

.sidebar.expanded .sidebar-link-vertical {
  flex-direction: row;
  justify-content: flex-start;
  padding: 10px 20px;
  padding-left: 0;
}

.sidebar.expanded .sidebar-text-home,
.sidebar.expanded .sidebar-text {
  margin-left: 10px;
  margin-top: 0;
  text-align: left;
  display: inline-block;
  font-size: 14px;
}

.sidebar.compressed .sidebar-link-vertical {
  flex-direction: column;
  justify-content: center;
}

.sidebar.compressed .sidebar-text-home,
.sidebar.compressed .sidebar-text {
  margin-left: 0;
  margin-top: 5px;
  text-align: center;
  font-size: 12px;
}

.sidebar.expanded .sidebar-footer .sidebar-link-vertical {
  flex-direction: row;
  justify-content: flex-start;
  padding: 10px 20px;
  padding-left: 10px;
}

.sidebar.expanded .sidebar-footer .sidebar-text {
  margin-left: 10px;
  margin-top: 0;
  text-align: left;
  display: inline-block;
  font-size: 14px;
}

.sidebar.compressed .sidebar-footer .sidebar-link-vertical {
  flex-direction: column;
  justify-content: center;
}

.sidebar.compressed .sidebar-footer .sidebar-text {
  margin-left: 0;
  margin-top: 5px;
  text-align: center;
  font-size: 12px;
}

.sidebar-link-vertical:hover {
  color: var(--mp-text-color--hover);
}

.sidebar-link-vertical:hover .sidebar-text-home,
.sidebar-link-vertical:hover .sidebar-text {
  color: var(--mp-text-color--hover);
}

.sidebar.expanded + .content {
  margin-left: 200px;
}

.sidebar-logo-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
  margin-top: 0;
}

.sidebar-logo {
  width: 40px;
  height: auto;
  transition: width 0.3s ease-in-out;
}

.sidebar.compressed .sidebar-logo {
  width: 40px;
}`, "",{"version":3,"sources":["webpack://./src/Layouts/Sidebar/Sidebar.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,mDAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,MAAA;EACA,WAAA;EACA,8BAAA;EACA,OAAA;EACA,kCAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AACJ;;AAEE;EACE,gBAAA;EACA,kDAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;AACJ;;AACE;EACE,iBAAA;AAEJ;;AAAE;EACE,oBAAA;AAGJ;;AADE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;AAIJ;;AAFE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;AAKJ;;AAHE;EACE,iCAAA;AAMJ;;AAJE;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iCAAA;EACA,UAAA;EACA,qBAAA;AAOJ;;AALE;EACE,kBAAA;AAQJ;;AANE;EACE,iBAAA;EACA,eAAA;AASJ;;AAPE;;EAAA;AAGA;EACE,gBAAA;AAUJ;;AARE;EACE,gBAAA;AAWJ;;AATE;EACE,WAAA;AAYJ;;AAVE;EACE,YAAA;AAaJ;;AAXE;EACE,eAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,wCAAA;EACA,iCAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EAEA,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,6DAAA;EACA,aAAA;AAaJ;;AAXE;EACE,sCAAA;EACA,YAAA;AAcJ;;AAZE;EACE,qBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;AAeJ;;AAZE;EACE,UAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sCAAA;AAeJ;;AAbE;EACE,eAAA;EACA,kBAAA;AAgBJ;;AAdE;EACE,iBAAA;EACA,qBAAA;AAiBJ;;AAfE;EACE,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,eAAA;AAkBJ;;AAhBE;;EAEE,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;AAmBJ;;AAjBE;EACE,sBAAA;EACA,uBAAA;AAoBJ;;AAlBE;;EAEE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;AAqBJ;;AAnBE;EACE,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,kBAAA;AAsBJ;;AAnBE;EACE,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;AAsBJ;;AAnBE;EACE,sBAAA;EACA,uBAAA;AAsBJ;;AApBE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;AAuBJ;;AArBE;EACE,kCAAA;AAwBJ;;AArBE;;EAEE,kCAAA;AAwBJ;;AAtBE;EACE,kBAAA;AAyBJ;;AAvBE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;AA0BJ;;AAxBE;EACE,WAAA;EACA,YAAA;EACA,kCAAA;AA2BJ;;AAzBE;EACE,WAAA;AA4BJ","sourcesContent":[".sidebar{\n    width: 200px;\n    background-color: var( --mp-tree-item-current-color);\n    color: white;\n    padding: 15px;\n    position: fixed;\n    top: 0;\n    bottom: 0px;\n    /*height: calc(100vh - 70px);*/\n    left: 0;\n    transition: width 0.3s ease-in-out;\n    overflow: visible;\n    display: flex;\n    flex-direction: column;\n    z-index: 1000;\n    \n  }\n  .sidebar-footer{\n    margin-top: auto;\n    background-color: var(--mp-view-bar-current-color);\n    padding: 0px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    height: 58px;\n    display: none;\n  }\n  .sidebar-footer .feedback-icon{\n    margin-right: 5px;\n  }\n  .sidebar-footer .sidebar-text{\n    padding-bottom: 20px;\n  }\n  .sidebar-link-vertical{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    margin-top: 10px;\n    width: 100%;\n  }\n  .feedback-icon{\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    font-size: 16px;\n  }\n  .sidebar-link-vertical .sidebar-text-home{\n    font-family: 'Microsoft JhengHei';\n  }\n  .sidebar-link-vertical .sidebar-text{\n    margin-left: 10px;\n    margin-top: 5px;\n    text-align: center;\n    font-size: small;\n    font-family: 'Microsoft JhengHei';\n    padding: 0;\n    display: inline-block;\n  }\n  .sidebar.expanded + .content{\n    margin-left: 200px;\n  }\n  .sidebar.compressed+.content{\n    margin-left: 70px;\n    margin-right: 0;\n  }\n  /*.sidebar-link-vertical svg{\n    margin-bottom: 5px;\n  }*/\n  .feedback-icon .sidebar-text{\n    margin-left: 5px;\n  }\n  .feedback-icon span{\n    margin-left: 5px;\n  }\n  .sidebar.compressed{\n    width: 70px;\n  }\n  .sidebar.expanded{\n    width: 200px;\n  }\n  .sidebar-toggle{\n    cursor: pointer;\n    border: black;\n    width: 29px;\n    height: 29px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 50%;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n    transition: background-color 0.3s;\n    padding: 10px;\n    position: absolute;\n    right: -14.5px;\n    // left: 60px;\n    top: 60px;\n    background-color: white;\n    text-align: center;\n    transition: transform 0.3s ease-in-out, background-color 0.3s;\n    z-index: 5000;\n  }\n  .sidebar-toggle svg{\n    transition: transform 0.3s ease-in-out;\n    color: black;\n  }\n  .sidebar ul{\n    list-style-type: none;\n    padding: 0;\n    margin-top: 0;\n    white-space: nowrap;\n  \n  }\n  .sidebar ul li{\n    padding:  0;\n    cursor: pointer;\n    font-size: 14px;\n    display: flex;\n    align-items: center;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n    transition: font-size 0.3s ease-in-out;\n  }\n  .sidebar.compressed ul li{\n    font-size: 12px;\n    text-align: center;\n  }\n  .sidebar ul li .sidebar-text{\n    margin-left: 10px;\n    display: inline-block;\n  }\n  .sidebar.expanded .sidebar-link-vertical{\n    flex-direction: row;\n    justify-content: flex-start;\n    padding: 10px 20px;\n    padding-left: 0;\n  }\n  .sidebar.expanded .sidebar-text-home,\n  .sidebar.expanded .sidebar-text{\n    margin-left: 10px;\n    margin-top: 0;\n    text-align: left;\n    display: inline-block;\n    font-size: 14px;\n  }\n  .sidebar.compressed .sidebar-link-vertical{\n    flex-direction: column;\n    justify-content: center;\n  }\n  .sidebar.compressed .sidebar-text-home,\n  .sidebar.compressed .sidebar-text{\n    margin-left: 0;\n    margin-top: 5px;\n    text-align: center;\n    font-size: 12px;\n  }\n  .sidebar.expanded .sidebar-footer .sidebar-link-vertical{\n    flex-direction: row;\n    justify-content: flex-start;\n    padding: 10px 20px;\n    padding-left: 10px;\n    \n  }\n  .sidebar.expanded .sidebar-footer .sidebar-text{\n    margin-left: 10px;\n    margin-top: 0;\n    text-align: left;\n    display: inline-block;\n    font-size: 14px;\n    \n  }\n  .sidebar.compressed .sidebar-footer .sidebar-link-vertical{\n    flex-direction: column;\n    justify-content: center;\n  }\n  .sidebar.compressed .sidebar-footer .sidebar-text{\n    margin-left: 0;\n    margin-top: 5px;\n    text-align: center;\n    font-size: 12px;\n  }\n  .sidebar-link-vertical:hover{\n    color: var(--mp-text-color--hover);\n  }\n  \n  .sidebar-link-vertical:hover .sidebar-text-home,\n  .sidebar-link-vertical:hover .sidebar-text{\n    color: var(--mp-text-color--hover);\n  }\n  .sidebar.expanded + .content{\n    margin-left: 200px;\n  }\n  .sidebar-logo-container{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 30px;\n    margin-top: 0;\n  }\n  .sidebar-logo{\n    width: 40px;\n    height: auto;\n    transition: width 0.3s ease-in-out;\n  }\n  .sidebar.compressed .sidebar-logo{\n    width: 40px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
